if (!customElements.get("m-icon-box")) {
  class MIconbox extends HTMLElement {
    constructor() {
      super();

      this.enableSlider = this.dataset.enableSlider === "true";
      this.items = this.dataset.items;
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.slideContainer = this.querySelector(".swiper-container");

      this.enableFade = this.dataset.enableFade === "true";
      this.fadeInterval = parseInt(this.dataset.fadeInterval) || 4000;
      this.fadePauseOnHover = this.dataset.fadePauseOnHover === "true";
    }

    connectedCallback() {
      this.lastActive = null;
      if (this.enableSlider) this.initSlider();
      if (this.enableFade) this.initFade();
    }

    disconnectedCallback() {
      this.stopFade();
      if (this.fadeObserver) {
        this.fadeObserver.disconnect();
        this.fadeObserver = null;
      }
    }

    initFade() {
      this.fadePages = Array.from(this.querySelectorAll(".m-icon-box__fade-page"));
      this.fadeDots = Array.from(this.querySelectorAll(".m-icon-box__fade-dot"));
      this.fadeIndex = 0;
      if (this.fadePages.length < 2) return;

      this.fadeDots.forEach((dot) => {
        dot.addEventListener("click", () => {
          this.showFadePage(Number(dot.dataset.fadeDot));
          this.startFade();
        });
      });

      if (this.fadePauseOnHover) {
        this.addEventListener("mouseenter", () => this.stopFade());
        this.addEventListener("mouseleave", () => this.startFade());
      }
      this.addEventListener("focusin", () => this.stopFade());
      this.addEventListener("focusout", () => this.startFade());

      // Only rotate while the section is actually on screen.
      this.fadeObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => (entry.isIntersecting ? this.startFade() : this.stopFade()));
      });
      this.fadeObserver.observe(this);

      document.addEventListener("shopify:block:select", (e) => this.onFadeBlockSelect(e));
      document.addEventListener("shopify:block:deselect", () => this.startFade());
    }

    showFadePage(index) {
      if (!this.fadePages || !this.fadePages.length) return;
      this.fadeIndex = (index + this.fadePages.length) % this.fadePages.length;

      this.fadePages.forEach((page, i) => {
        const isActive = i === this.fadeIndex;
        page.classList.toggle("is-active", isActive);
        isActive ? page.removeAttribute("aria-hidden") : page.setAttribute("aria-hidden", "true");
      });

      this.fadeDots.forEach((dot, i) => {
        const isActive = i === this.fadeIndex;
        dot.classList.toggle("is-active", isActive);
        dot.setAttribute("aria-selected", isActive ? "true" : "false");
      });
    }

    startFade() {
      this.stopFade();
      if (!this.fadePages || this.fadePages.length < 2) return;
      this.fadeTimer = setInterval(() => this.showFadePage(this.fadeIndex + 1), this.fadeInterval);
    }

    stopFade() {
      if (this.fadeTimer) {
        clearInterval(this.fadeTimer);
        this.fadeTimer = null;
      }
    }

    onFadeBlockSelect(e) {
      const page = e.target.closest(".m-icon-box__fade-page");
      if (!page || !this.contains(page)) return;
      this.stopFade();
      this.showFadePage(Number(page.dataset.fadePage));
    }

    initSlider() {
      const controlsContainer = this.querySelector(".m-slider-controls");
      const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");
      const slideItemsLength = this.querySelector(".swiper-wrapper").childElementCount;
      let __this = this;

      this.slider = new MinimogLibs.Swiper(this.slideContainer, {
        slidesPerView: 1,
        navigation: this.showNavigation,
        loop: true,
        pagination: this.showPagination
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
            }
          : false,
        breakpoints: {
          480: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: parseInt(this.items) - 1,
          },
          1280: {
            slidesPerView: parseInt(this.items),
          },
        },
        on: {
          init: function () {
            this.slideToLoop(this.lastActive);
            setTimeout(() => {
              // Calculate controls position
              const firstItem = __this.querySelector(".m-image") || __this.querySelector(".m-placeholder-svg");
              if (firstItem && controlsContainer) {
                const itemHeight = firstItem.clientHeight;
                controlsContainer.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");

                prevButton.classList.remove("m:hidden");
                nextButton.classList.remove("m:hidden");
              }
            }, 200);
          },
          breakpoint: (swiper, breakpointParams) => {
            if (controlsContainer) {
              const { slidesPerView } = breakpointParams;
              if (slideItemsLength > slidesPerView) {
                controlsContainer.classList.remove("m:hidden");
                swiper.allowTouchMove = true;
              } else {
                controlsContainer.classList.add("m:hidden");
                swiper.allowTouchMove = false;
              }
            }
          },
        },
      });

      if (this.slider && this.showNavigation) {
        prevButton && prevButton.addEventListener("click", () => this.slider.slidePrev());
        nextButton && nextButton.addEventListener("click", () => this.slider.slideNext());
      }
      document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
    }

    onBlockSelect(e) {
      const block = e.target;
      const index = Number(block.dataset.slide);
      this.lastActive = index;
      if (this.slider) {
        this.slider.slideToLoop(index);
      }
    }
  }

  customElements.define("m-icon-box", MIconbox);
}
